import React, { useState, useEffect, useRef } from 'react';
import '../CreateProduct.css';
import NotFound from '../../../Images/notFound.png';
import {
  Button,
  makeStyles, Paper,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Select,
  MenuItem
} from '@material-ui/core';
import clsx from 'clsx';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getTodaySupplyOrderDocument, updateSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import CustomAlert from '../../CustomAlert';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}));

function MedicineReturns() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [openNotify, setOpenNotify] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [TodayDate, setTodayDate] = useState(parseDate(new Date()));
  const [ChemistEntry, setChemistEntry] = useState([]);
  const [supplyOrderList, setSupplyOrderList] = useState([]);
  const [todayMedicineList, setTodayMedicineList] = useState([]);
  const [feedbackText, setFeedbackText] = useState('');
  const [targetMedicineId, setTargetMedicineId] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userData } = CheckUserProvider();


  useEffect(async () => {
    if (userData) {
      try {
        setIsLoading(true);
        const getSupplyOrder = await getTodaySupplyOrderDocument();
        setSupplyOrderList(getSupplyOrder);

        const todaysMedicine = getSupplyOrder.filter(x =>
          parseDate(x.SupplyOrderPostedDateTime).includes(TodayDate)
        );
        setTodayMedicineList(todaysMedicine);

        const filteredReturnedItems = todaysMedicine?.filter(x => x?.Status === "returned");
        setChemistEntry(filteredReturnedItems);
        setIsLoading(false);
      } catch (error) {
        console.log("Error Occur in Get Order", error);
        setIsLoading(false);
      }
    }
  }, [userData]);

  const handleTodayDateChange = (e) => {
    setTodayDate(parseDate(e.target.value));
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(parseDate(e.target.value))
    );
    setTodayMedicineList(filterRecord);

    const filteredReturnedItems = filterRecord?.filter(x => x?.Status === "returned");
    setChemistEntry(filteredReturnedItems);
    setIsLoading(false);
  };

  const onClear = () => {
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(parseDate(TodayDate))
    );
    setTodayMedicineList(filterRecord);

    const filteredReturnedItems = filterRecord?.filter(x => x?.Status === "returned");
    setChemistEntry(filteredReturnedItems);
    setIsLoading(false);
  };

  const onTapNextButton = async () => {
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(TodayDate)
    );
    setTodayMedicineList(filterRecord);

    const filteredReturnedItems = filterRecord?.filter(x => x?.Status === "returned");
    setChemistEntry(filteredReturnedItems);
    setIsLoading(false);
  };

  const handleOnSearch = (string, results) => {
    console.log('handleOnSearch', string, results)
    string?.length == 0 && setChemistEntry([]);
  }

  // Modify handleOnSelect to respect excludedItems
  const handleOnSelect = (item) => {
    const filteredItems = todayMedicineList?.filter(x => x?.ProductName?.toLowerCase()?.includes(item?.ProductName?.toLowerCase()));
    setChemistEntry(filteredItems);
  };

  const handleFeedbackItem = (_id) => {
    setTargetMedicineId(_id);
    setIsPopupOpen(true);
  };

  const handleSubmitFeedbackItem = () => {
    if (targetMedicineId && targetMedicineId != null) {
      const selectedRecord = ChemistEntry.find(item => item._id === targetMedicineId);
      if (!selectedRecord) {
        setNotificationMessage('No changes made for Feedback.');
        setOpenNotify(true);
        setAlertType('error');
        setIsPopupOpen(false);
        return;
      }
      if (feedbackText && feedbackText != "") {
        try {
          const updatedRecord = {
            ...selectedRecord,
            Status: 'returned',
            Feedback: feedbackText
          }
          const response = updateSupplyOrderDocument(updatedRecord);
          if (response) {
            const updatedChemistEntry = ChemistEntry.map(item =>
              item._id === targetMedicineId ? {
                ...item,
                Status: 'returned',
                Feedback: feedbackText
              } : item
            );
            setChemistEntry(updatedChemistEntry);

            setNotificationMessage('Feedback Update successfully.')
            setOpenNotify(true)
            setAlertType('success')
          } else {
            setNotificationMessage('Failed to update Feedback.')
            setOpenNotify(true)
            setAlertType('error')
          }
          setIsPopupOpen(false);
        } catch (error) {
          console.log('Error updating product name:', error);
          setIsPopupOpen(false);
        }
      } else {
        setNotificationMessage('Please select return reason!');
        setOpenNotify(true);
        setAlertType('error');
      }
    } else {
      setNotificationMessage('No Action to Perform, Please try after sometimes.');
      setOpenNotify(true);
      setAlertType('error');
      setIsPopupOpen(false);
    }
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.ProductName}
        </span>
      </>
    );
  };

  return (
    <>
      <div className="createProduct mt-2">
        {isLoading && <div className="loader-container">
          <div className="loader"></div>
        </div>}
        <Helmet>
          <meta name="description" content="Creating New Product And Sales page." />
          <title>Medicine Returns | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12">
              <h5 className="mt-3 text-center">Return/Bounce Medicine for Chemist &nbsp; </h5>
              <div className="row mb-3">
                <div className="col-md-8 mb-2">
                  <ReactSearchAutocomplete
                    items={todayMedicineList} // Filter excluded items
                    // items={todayMedicineList.filter(item => !excludedItems.includes(item._id))} // Filter excluded items
                    placeholder="Search Medicine..."
                    fuseOptions={{ keys: ['ProductName'] }}
                    resultStringKeyName="ProductName"
                    onSearch={handleOnSearch}
                    onSelect={handleOnSelect}
                    autoFocus
                    formatResult={formatResult}
                    styling={{
                      borderRadius: '8px',
                      zIndex: 1000,
                    }}
                    onClear={onClear}
                  />
                </div>
                <div className="col-md-3 mb-2">
                  <span className="form-control registerEmp__textbox registerEmp__datePicker">
                    <DatePickerComponent
                      id="TodayDate"
                      name="TodayDate"
                      value={TodayDate}
                      cssclassName="e-outline"
                      onChange={(e) => handleTodayDateChange(e)}
                      format="dd/MM/yyyy"
                      cleared={() => setTodayDate('')}
                    />
                  </span>
                </div>
                <div className="col-md-1 mb-2 mt-1">
                  <div className="addBox">
                    <Button
                      onClick={onTapNextButton}
                      variant="contained"
                      className="registerEmp__btnLogin jsmAdd"
                    >
                      {'Next'}
                    </Button>
                  </div>
                </div>
              </div>

              {ChemistEntry?.length > 0 ? (
                <div className="row mb-3 ml-5 table-overflow">
                  <h6>Search Result:</h6>
                  <table className="table">
                    <thead>
                      <tr>
                        <td><b>Chemist Info</b></td>
                        <td><b>Product Name</b></td>
                        <td><b>Quantity</b></td>
                        <td><b>Scheme</b></td>
                        <td><b>Wholesaler Info</b></td>
                        <td><b>Feedback</b></td>
                        <td><b>Date</b></td>
                        <td><b>Action</b></td>
                      </tr>
                    </thead>
                    <tbody>
                      {ChemistEntry.map((chemist, index) => {
                        return (
                          <tr key={chemist._id}>
                            <td>{chemist?.ChemistInfo}</td>
                            <td>{chemist?.ProductName}</td>
                            <td>{chemist?.ProductQuantity || "NA"}</td>
                            <td>{chemist?.ProductScheme || "NA"}</td>
                            <td>{chemist?.WholesalerId || "NA"}</td>
                            <td><b>{`${chemist?.Status || ""} - ${chemist?.Feedback || ""}` || "NA"}</b></td>
                            <td>{typeof chemist?.SupplyOrderPostedDateTime === "string"
                              ? chemist?.SupplyOrderPostedDateTime
                              : parseDate(chemist?.SupplyOrderPostedDateTime).toLocaleString()}</td>
                            <td className="deleteCursor markSelectedWidth">
                              <Button
                                onClick={() => handleFeedbackItem(chemist._id)}
                                variant="contained"
                                className="greenColor"
                                style={{ backgroundColor: 'green !important' }} >
                                {'Feedback'}
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              ) : <div className="row col-md-12 mt-3 text-center">
                <img src={NotFound} className="notFound" />
                <h4>No Goods Found for Return!</h4>
              </div>}
            </div>
          </div>
        </Paper>
      </div>
      <Dialog
        open={isPopupOpen}
        onClose={() => {
          setIsPopupOpen(false);
          setTargetMedicineId(null);
          setFeedbackText("");
        }}
        fullWidth
        maxWidth="sm" // Options: 'xs', 'sm', 'md', 'lg', 'xl'
        PaperProps={{
          style: {
            padding: '20px',
            minWidth: '400px',
            minHeight: '200px',
          },
        }}>
        <DialogTitle>Return/Bounce Medicine Feedback</DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-12">
              Enter Reason <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
              <select
                className={"form-select registerEmp__textbox"}
                onChange={(e) => setFeedbackText(e.target.value)}
                name="feedbackText"
                required
                defaultValue="Select Reason Type" >
                <option value="">Select Option</option>
                <option value={'Incorrect scheme'}>{'Incorrect scheme'}</option>
                <option value={'Different Product'}>{'Different Product'}</option>
                <option value={'Damaged Product'}>{'Damaged Product'}</option>
                <option value={'Expired Item'}>{'Expired Item'}</option>
                <option value={'Extra Quantities'}>{'Extra Quantities'}</option>
                <option value={'Bounce'}>{'Bounce'}</option>
              </select>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setIsPopupOpen(false);
            setTargetMedicineId(null);
            setFeedbackText("");
          }} color="secondary">
            Close
          </Button>
          <Button onClick={handleSubmitFeedbackItem} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
        notificationMessage={notificationMessage} verticalPosition="top" horizontalPosition="right" />
    </>
  );
}

export default MedicineReturns;

